import { IDanhSachMoMonRequest } from "../../state/reducer-model/lop-tin-chi/IDanhSachMoMonReducer";
import { apiClient } from "../apiClient";
export const DANH_SACH_MO_MON_API = "danh-sach-mo-mon";
export const danhSachMoMonApi = {
  ExportExcel: (request: IDanhSachMoMonRequest) =>
    apiClient.post(`${DANH_SACH_MO_MON_API}/export-excel`, request),
};
